import * as THREE from "three";
import React from "react";

// Assets, image size 1200x600
import comingSoon from "../../images/works/coming-soon.jpg";
import lotteXmas from "../../images/works/preview-lottexmas.png";
import everland from "../../images/works/preview-everland.jpg";
import ghs from "../../images/works/preview-ghs.jpg";
import editor from "../../images/works/preview-editor.jpg";

/**
 * Make image plane
 * @param preview
 * @param projectId
 * @returns {*}
 * @constructor
 */
const ProjectImage = ({ projectId }) => {
  const loader = new THREE.TextureLoader();
  // const backgroundTexture = textureLoader.load(preview);
  let texture = null;

  switch (projectId) {
    case "comingSoon":
      texture = loader.load(comingSoon);
      break;
    case "lotte-xmas":
      texture = loader.load(lotteXmas);
      break;
    case "everland":
      texture = loader.load(everland);
      break;
    case "ghs":
      texture = loader.load(ghs);
      break;
    case "editor":
      texture = loader.load(editor);
      break;
  }

  return (
    texture && (
      <mesh>
        <planeGeometry args={[90, 45]} />
        <meshStandardMaterial map={texture} />
      </mesh>
    )
  );
};

export default ProjectImage;
